import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../services/supabaseClient';
interface AuthorProfile { id: string; first_name?: string; last_name?: string; username: string; avatar_url?: string; bio?: string; }
const AuthorsPage: React.FC = () => {
  const [authors, setAuthors] = useState<AuthorProfile[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    const fetchAuthors = async () => {
      try {
        const { data, error } = await supabase.from('profiles').select('id, first_name, last_name, username, avatar_url, bio').eq('is_writer', true);
        if (error) throw error;
        if (active) setAuthors(data || []);
      } catch { if (active) setError(true); }
      finally { if (active) setLoading(false); }
    };
    fetchAuthors();
    return () => { active = false; };
  }, []);
  return <div className="editorial-shell archive-page"><header className="archive-heading"><h1>Our writers<span>.</span></h1></header>
    {loading ? <div className="editorial-empty" role="status">Loading our writers…</div> : error ? <div className="editorial-empty">Unable to load writers right now.</div> : authors.length ? <div className="author-grid">{authors.map((author, index) => <Link to={`/writer/${author.id}`} key={author.id} className="author-card"><span className="eyebrow">Contributor / {String(index + 1).padStart(2, '0')}</span><h2>{[author.first_name, author.last_name].filter(Boolean).join(' ') || author.username}</h2>{author.bio && <p>{author.bio}</p>}</Link>)}</div> : <div className="editorial-empty">Our contributors are coming soon.</div>}
  </div>;
};
export default AuthorsPage;
